import React, { useState } from "react";

import { useParams } from "react-router-dom";
import { useEffect, useContext } from "react";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import Icon from "@mui/material/Icon";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

import TextField from "@mui/material/TextField";

import Button from "@mui/material/Button";
import { LanguageContext } from "App";

import CardHeader from "@mui/material/CardHeader";
import Loader from "Loader";
import SearchFacilityTypeReq from "Classes/Models/Requests/Administration/SearchFacilityTypeReq";
import CreateFacilityTypeReq from "Classes/Models/Requests/Administration/CreateFacilityTypeReq";
import FacilitiesApi from "Classes/API/Administration/FacilitiesApi";
import Swal from "sweetalert2";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
const EditFacilityType = () => {
  const { id } = useParams();

  const [TypeName, setTypeName] = useState("");
  const [Description, setDescription] = useState("");
  const [Category, setCategory] = useState("");
  const [ErrorText, setErrorText] = useState(false);
  const [SuccessText, setSuccessText] = useState("");
  const [IsLoaded, SetIsLoaded] = useState(false);

  const { translations } = useContext(LanguageContext);

  const GetData = async () => {
    let employeeModel = new SearchFacilityTypeReq();
    employeeModel.searchInt = parseInt(id);
    var res = await FacilitiesApi.GetFacilityTypeById(employeeModel);
    if (res.status == "Success") {
      let response = res.data;

      setTypeName(response.typeName);
      setDescription(response.description);
      setCategory(response.category);
      SetIsLoaded(true);
    }
  };

  useEffect(async () => {
    if (!IsLoaded) {
      await GetData();
    }
  }, [IsLoaded]);

  if (!IsLoaded) {
    return <div>LOADING...</div>;
  }

  const SaveEdit = async () => {
    let model = new CreateFacilityTypeReq();
    if (!TypeName || !Description || !Category) {
      setErrorText(true);
      return;
    }

    model.Id = id;
    model.TypeName = TypeName;
    model.Description = Description;
    model.Category = Category;
    await FacilitiesApi.EditFacilityType(model).then((res) => {
      if (res.status == "Success") {
        Swal.fire({
          title: "Success",
          text: "Facility Type Updated Successfully",
          icon: "success",
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Error Updating Facility Type",
          icon: "error",
        });
      }
    });
  };

  return (
    <DashboardLayout>
      {/* Page Title */}
      <DashboardNavbar />

      {/* Search form */}
      <div className="card mt-3">
        <div className="card-body">
          <CardHeader
            className="mb-2"
            title={translations.FacilityPagesCreatenewFacilityTypeEditFacilityType}
          ></CardHeader>
          <div className={translations.setlang === "ar" ? "rtl-label" : ""}>
            <div className="container-fluid">
              <div className="row">
                {/* typename */}
                <div className="col-md-4">
                  <TextField
                    className="full-width"
                    label={translations.EmployeeTypetableTypename}
                    type="text"
                    defaultValue={TypeName}
                    onChange={(e) => setTypeName(e.target.value)}
                    fullWidth
                  />
                </div>

                {/* Description */}
                <div className="col-md-4">
                  <TextField
                    className="full-width"
                    label={translations.FacilityPagesCreatenewFacilityTypedescription}
                    type="text"
                    defaultValue={Description}
                    onChange={(e) => setDescription(e.target.value)}
                    fullWidth
                  />
                </div>

                {/* Category */}
                <div className="col-md-4">
                  <TextField
                    className="full-width"
                    label={translations.FacilityPagesCreatenewFacilityTypecategory}
                    type="text"
                    defaultValue={Category}
                    onChange={(e) => setCategory(e.target.value)}
                    fullWidth
                  />
                </div>
              </div>

              <div className="text-right mt-3 ">
                <Button
                  className="white"
                  sx={{ backgroundColor: "#3560AD" }}
                  size="medium"
                  onClick={SaveEdit}
                >
                  {translations.EmployeeTypetableSave}
                </Button>
              </div>

              {!TypeName && ErrorText == true && (
                <small
                  className="alert alert-danger font-sm mt-4 mx-0 text-right d-block"
                  role="alert"
                >
                  {" "}
                  برجاء إدخال الأسم{" "}
                </small>
              )}

              {!Description && ErrorText == true && (
                <small
                  className="alert alert-danger font-sm mt-4 mx-0 text-right d-block"
                  role="alert"
                >
                  {" "}
                  برجاء إدخال الوصف{" "}
                </small>
              )}

              {!Category && ErrorText == true && (
                <small
                  className="alert alert-danger font-sm mt-4 mx-0 text-right d-block"
                  role="alert"
                >
                  {" "}
                  برجاء إدخال التصنيف{" "}
                </small>
              )}
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default EditFacilityType;
